import { Briefcase, User } from "lucide-react";

import type { BusinessEntityDetailVO } from "@/api/entities/type";
import { SectionTitle } from "@/components/DetailBlocks";

import { DetailInfoRow } from "./detailParts";

/** 法定代表人信息 Tab */
export const LegalInfoTab = ({ detail }: { detail: BusinessEntityDetailVO | null }) => (
  <div className="space-y-5">
    <div>
      <SectionTitle icon={User} title="法定代表人" />
      <div className="grid grid-cols-2 gap-x-6 gap-y-2.5">
        <DetailInfoRow icon={User} label="姓名" value={detail?.operName} />
        {detail?.title && <DetailInfoRow icon={Briefcase} label="职务" value={detail.title} />}
      </div>
    </div>
  </div>
);
